import styled from 'styled-components'

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: var(--radius-lg);
  border: 1px solid var(--vo-cloud);
  background: white;
`

export const SearchHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`

export const Title = styled.span`
  font-family: var(--font-primary);
  font-size: 18px;
  font-weight: 600;
  color: var(--vo-ink);
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 650px;

  ${({ $noData, $applyMB }) =>
    ($noData || $applyMB) ? 'margin-bottom: 16px;' : ''}
`

export const TableHead = styled.thead`
  background-color: var(--vo-mist);
`

export const TableHeadCell = styled.th`
  font-family: var(--font-secondary);
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--vo-slate);
  border-bottom: 2px solid var(--vo-cloud);
  padding: 12px 16px;
  text-align: left;
  white-space: nowrap;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  user-select: none;

  &:hover {
    color: ${({ $sortable }) => ($sortable ? 'var(--color-brand)' : 'var(--vo-slate)')};
  }
`

export const SortArrow = styled.span`
  display: inline-flex;
  flex-direction: column;
  margin-left: 4px;
  font-size: 10px;
  line-height: 1;
  vertical-align: middle;
  color: ${({ $active }) => ($active ? 'var(--color-brand)' : 'var(--vo-slate)')};
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    background-color: var(--vo-capri-25);
  }

  td {
    border-bottom: 1px solid var(--vo-cloud);
    padding: 12px 16px;
    font-size: 14px;
    color: var(--vo-ink);
  }
`

export const TableCell = styled.td`
  max-width: ${({ $maxWidth }) => $maxWidth || '300px'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const NoDataCell = styled.td`
  text-align: center;
  padding: 24px 16px;
  color: var(--vo-slate);
  font-size: 14px;
  border-bottom: 1px solid var(--vo-cloud);
`

export const ActionCell = styled.td`
  text-align: center;
  min-width: ${({ $minWidth }) => $minWidth || '120px'};
  white-space: nowrap;
`

export const ActionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $danger }) => $danger ? 'var(--vo-danger)' : 'var(--color-brand)'};
  margin: 0 2px;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ $danger }) => $danger ? 'var(--vo-pink-600)' : 'var(--color-brand-strong)'};
  }
`

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid var(--vo-cloud);
  gap: 16px;
  font-size: 14px;
  color: var(--vo-ink);
`

export const RowsPerPage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const RowsPerPageSelect = styled.select`
  border: 1px solid var(--vo-cloud);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  color: var(--vo-ink);
  background: white;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: var(--color-brand);
  }
`

export const PageNav = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PageButton = styled.button`
  border: 1px solid var(--vo-cloud);
  border-radius: 4px;
  background: white;
  color: ${({ $disabled }) => ($disabled ? 'var(--vo-steel)' : 'var(--vo-ink)')};
  padding: 4px 10px;
  font-size: 14px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  &:hover:not(:disabled) {
    background: var(--vo-mist);
  }
`

export const PageInfo = styled.span`
  margin: 0 8px;
  font-size: 14px;
  color: var(--vo-slate);
`
